import format from 'date-fns/format';
import nlLocale from 'date-fns/locale/nl';

const formatDate = (date: Date, dateFormat = 'DD-MM-YYYY') => (
  format(date, dateFormat, { locale: nlLocale })
);

export default formatDate;
